'use client';
import styled, { css } from 'styled-components';
import { fromMd, timingDefault, timingFaster, timingSlower } from '../../constants';
import { ExpansionPanel } from '../ExpansionPanel';
export const List = styled.div(o => {
    const backgroundColor = (() => {
        if (o.$variant === 'filled')
            return o.theme.color.fill.background;
        if (o.$variant === 'subtle')
            return o.theme.color.fill.subtle;
        return 'transparent';
    })();
    return css `
    background: ${backgroundColor};
    color: ${o.theme.color.text.primary.on.background};
    margin: 0 auto;
    max-width: 100%;
    padding: 0;
    width: 100%;
  `;
});
export const Summary = styled(ExpansionPanel.Summary)(o => {
    const background = (() => {
        if (o.$variant === 'filled' || o.$variant === 'subtleWhileActive')
            return o.theme.color.fill.background;
        if (o.$variant === 'subtle')
            return o.theme.color.fill.subtle;
        return 'transparent';
    })();
    const activeBackground = (() => {
        if (o.$variant === 'filled')
            return o.theme.color.fill.background;
        if (o.$variant === 'subtle' || o.$variant === 'subtleWhileActive')
            return o.theme.color.fill.subtle;
        return 'transparent';
    })();
    const color = o.theme.color.text.primary.on.background;
    const hoverColor = o.theme.color.text.secondary.on.background;
    return css `
    color: ${color};
    &:hover {
      color: red;
    }
    align-items: center;
    background: ${background};
    padding: ${o => o.theme.spacing(6)};
    width: 100%;
    transition: ${o.$withAnimation
        ? `${timingSlower} background ease, ${timingFaster} color ease`
        : 'none'};
    &[aria-expanded='true'] {
      background: ${activeBackground};
    }
    &:hover {
      color: ${hoverColor};
    }
  `;
});
export const Header = styled.div `
  color: inherit;
  flex-basis: 95%;
`;
export const HeaderControl = styled.div `
  flex-basis: 5%;
  text-align: right;
`;
export const HeaderIcon = styled.span ``;
export const Details = styled(ExpansionPanel.Details)(o => {
    const background = (() => {
        if (o.$variant === 'filled' || o.$variant === 'subtleWhileActive')
            return o.theme.color.fill.background;
        if (o.$variant === 'subtle')
            return o.theme.color.fill.subtle;
        return 'transparent';
    })();
    const activeBackground = (() => {
        if (o.$variant === 'filled')
            return o.theme.color.fill.background;
        if (o.$variant === 'subtle' || o.$variant === 'subtleWhileActive')
            return o.theme.color.fill.subtle;
        return 'transparent';
    })();
    return css `
    background: ${background};
    padding-left: ${o => o.theme.spacing(6)};
    padding-right: ${o => o.theme.spacing(6)};
    padding-bottom: 0;
    transition: ${o.$withAnimation
        ? `grid-template-rows ${timingDefault} ease, background ${timingSlower} ease`
        : 'none'};

    /** Transition opacity of inner content */
    * {
      transition: ${o.$withAnimation ? `opacity ${timingSlower} ease` : 'none'};
      opacity: 0;
    }
    &[data-enter] {
      background: ${activeBackground};
      padding-bottom: ${o => o.theme.spacing(6)};
      * {
        opacity: 1;
      }
    }

    ${fromMd} {
      padding-left: 0;
      padding-right: 0;
    }
  `;
});
export const SectionContainer = styled(ExpansionPanel.Container)(o => {
    const border = (() => {
        if (o.$showBorder === false)
            return '1px solid transparent';
        return `1px solid ${o.theme.color.stroke.neutral.border.decoration.on.background}`;
    })();
    return css `
    border-bottom: ${border};
    &:last-child {
      border-bottom: none;
    }
  `;
});
//# sourceMappingURL=styles.js.map